module.exports = __webpack_public_path__ + "static/media/Vector.3647d810.svg";